import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  COURSES,
  DASHBOARD,
  FULLSCRIPT_ROUTES,
  MESSAGES_ROUTES,
  MY_ACCOUNT_ROUTES,
  MY_APPOINTMENT_ROUTES,
  MY_PATIENTS_ROUTES,
  NOT_FOUND_PAGE,
  NOTIFICATIONS_ROUTES,
  PROVIDER_SCHEDULED,
  TEST_KITS_MANAGEMENT_ROUTES,
} from 'utilities/routes';
import ProviderLayout from './Layout';
import NotFoundPage from '../NotFoundPage';
import {
  CoursesRoutes,
  DashboardPage,
  FullscriptRoutes,
  MyAppointmentsRoutes,
  MyAccountRoutes,
  MyMessagesRoutes,
  MyPatientsRoutes,
  NotificationsRoutes,
  ProviderSchedules,
  ManageTestKitsRoutes,
} from './providerLoaders';
import { ProviderStatusGuard } from './ProviderStatusGuard';

const ProviderRoutes = () => {
  return (
    <Routes>
      <Route element={<ProviderLayout />}>
        <Route element={<ProviderStatusGuard />}>
          <Route path={DASHBOARD} element={<DashboardPage />} />
          <Route path={MY_PATIENTS_ROUTES} element={<MyPatientsRoutes />} />
          <Route path={MESSAGES_ROUTES} element={<MyMessagesRoutes />} />
          <Route path={FULLSCRIPT_ROUTES} element={<FullscriptRoutes />} />
          <Route
            path={MY_APPOINTMENT_ROUTES}
            element={<MyAppointmentsRoutes />}
          />
          <Route path={PROVIDER_SCHEDULED} element={<ProviderSchedules />} />
          <Route path={`${COURSES}/*`} element={<CoursesRoutes />} />
          <Route
            path={NOTIFICATIONS_ROUTES}
            element={<NotificationsRoutes />}
          />
          <Route
            path={TEST_KITS_MANAGEMENT_ROUTES}
            element={<ManageTestKitsRoutes />}
          />
        </Route>
        <Route path={MY_ACCOUNT_ROUTES} element={<MyAccountRoutes />} />

        <Route path={NOT_FOUND_PAGE} element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to={DASHBOARD} replace />} />
      </Route>
    </Routes>
  );
};

export default ProviderRoutes;
